import axios from 'axios';
import { deleteCookie } from 'utils/cookie';
import {
  getLocalAccessToken,
  setLocalAccessToken,
  setLocalRefreshToken,
  removeLocalItem,
  Tokens,
  removeAccessItems,
} from './localStorage';

export const httpConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  method: 'POST',
};

export const httpClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use(
  (config) => {
    const accessToken = getLocalAccessToken();
    if (accessToken) {
      // @ts-ignore
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (res) => {
    if (res.headers['authorization']) {
      setLocalAccessToken(res.headers['authorization']);
    }

    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.response.headers['authorization']) {
      setLocalAccessToken(err.response.headers['authorization']);
    }

    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        alert('Срок действия токена истёк, необходимо авторизоваться');
        removeAccessItems();
        deleteCookie('user');
        window.location.reload();

        return Promise.reject(err.response.data);
      }
    }

    if (err.response.status === 403 && err.response.data) {
      return Promise.reject(err.response.data);
    }

    return Promise.reject(err);
  }
);
